import React from 'react'

export const Title = props => <h1 className="text-center text-3xl" {...props} />

export const Description = props => (
  <p className="text-base leading-snug my-4" {...props} />
)
